import Head from "../../elements/head/head";
import Footer from "../../elements/footer/footer";
import "./albom.scss";
import Paper from "@mui/material/Paper";
import { API_MEDIA } from "../../env";
import { styled } from "@mui/material/styles";
import Progress from "../../elements/progress/progress";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import FixedBottomNavigation from "../../elements/navigation/navigation";

import api from "../../api";
import { useSelector } from "react-redux";
import ListItem from "@mui/material/ListItem";
import RecipeReviewCard from "./card";

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Albom = (args) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [data_image_list, setData_image_list] = useState([]);
  const search = useSelector((state) => state.searchSelector.search);
  const countRef = useRef(0);
  const [totalTimeSpent, setTotalTimeSpent] = useState(null);

  const getAlbomFunc = () => {
    setLoading(true);
    api.getAlboms(search).then((response) => {
      console.log(search);
      setData(response.data.alboms);
      setData_image_list(response.data.files);
    });
    setLoading(false);
  };

  useEffect(() => {
    getAlbomFunc(search);
  }, [search]);

  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          {/* <div className="Container"> */}
          <Paper>
            <Grid
              // size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}
              spacing={1}
              padding={1}
              container
              direction="rows"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {data.length != 0 ? (
                data.map((item) => (
                  <Grid>
                    <RecipeReviewCard
                      title={item.title}
                      name={item.name}
                      description={item.description}
                      date={item.time_create}
                      image={API_MEDIA + item.image}
                      image_list={data_image_list[item.id]}
                    />
                  </Grid>
                ))
              ) : (
                <h3>
                  {" "}
                  Вас приветствует Рязанская Федерация пауэрлифтинга! Тут пока
                  нет ни одного документа!
                </h3>
              )}
            </Grid>
          </Paper>
          {/* </div> */}
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
        }}
        size={{ lg: 1, xl: 1 }}
      ></Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Albom;
